/**
 * Get data for the specified topics from the full data object.
 * @param {string[]} topics - An array of topic names to filter.
 * @param {object} allData - The full data object.
 */
export function getData(topics, allData) {
  if (!allData) {
    return { dates: [] };
  }

  let dates = [];
  if (allData.date && typeof allData.date === 'object') {
    const entries = Object.entries(allData.date)
      .filter(([k]) => /^\d+$/.test(k))
      .sort((a, b) => Number(a[0]) - Number(b[0]));
    dates = entries.map(([, v]) => v);
  } else if (Array.isArray(allData.date)) {
    dates = allData.date;
  }

  const existingTopics = topics.filter(t => Object.prototype.hasOwnProperty.call(allData, t));

  const filteredData = { dates };

  for (const topic of existingTopics) {
    const seriesObj = allData[topic];
    if (seriesObj && typeof seriesObj === 'object') {
      const topicValues = Object.entries(seriesObj)
        .filter(([k]) => /^\d+$/.test(k))
        .sort((a, b) => Number(a[0]) - Number(b[0]))
        .map(([, v]) => v);
      filteredData[topic] = topicValues;
    } else {
      filteredData[topic] = [];
    }
  }

  return filteredData;
}
